import { FormularioSituacao } from '../../../../../../_metronic/helpers'
import { createListFilters, IOption } from '../../../../../components'

export type AvaliacoesFilters = {
  paciente: string
  protocolo: string
  empresa?: IOption<number>
  situacao?: IOption<FormularioSituacao>
}

export const { ListFiltersProvider, useListFilters } = createListFilters<AvaliacoesFilters>({
  paciente: '',
  protocolo: '',
  empresa: undefined,
  situacao: undefined,
})
